import React, {Component} from 'react';
import Reveal from 'react-reveal';
import Player from "./videobtn";

class AppBanner extends Component{
    state = {
        open: false
    };

    onOpenModal = () => {
        this.setState(prevState => ({
            open: !prevState.open
        }));
    };
    render(){
        return(
            <section className="app_banner_area" id="home">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <Reveal bottom cascade>
                                <div className="app_banner_contentmt mt_40">
                                    <h2 className="f_p f_700 f_size_50 w_color mb_20 wow fadeInLeft" data-wow-delay="0.2s">Farming <br/>made Smart !</h2>
                                    <p className="f_400 f_size_18 l_height30 w_color wow fadeInLeft" data-wow-delay="0.3s">GreenHubLK by Team &lt;\BackSlash&gt;<br/> Simple. Innovative. Powerful.</p>
                                    <div className="action_btn d-flex align-items-center mt_40 wow fadeInLeft" data-wow-delay="0.6s">
                                        <button className="btn_hover app_btn" onClick={this.onOpenModal}><i className="ti-control-play"/>&nbsp;&nbsp; Watch Promo</button>
                                        <Player open={this.state.open} toggleModal={this.onOpenModal} />
                                    </div>
                                </div>
                            </Reveal>
                        </div>
                        <div className="col-lg-5">
                            <div className="app_img">
                                <img className="app_screen one wow fadeInDown" src={require('../../img/home7/01.png')} alt=""/>
                                <img className="app_screen two wow fadeInDown" src={require('../../img/home7/03.png')} alt=""/>
                                <img className="app_screen three wow fadeInDown" src={require('../../img/home7/02.png')} alt=""/>
                                <img className="mobile" src={require('../../img/home7/app.png')} alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }

}

export default AppBanner;
